import { TOUR_TRANSLATIONS } from "../translations"

export const getMonitoringResultsSteps = (lang) => {
    const t = TOUR_TRANSLATIONS[lang]

    return [
        {
            target: '[data-tour="monitoring-results-filters"]',
            title: t.monitoringResultsFilters.title,
            content: t.monitoringResultsFilters.content,
            disableBeacon: true,
        },
        {
            target: '[data-tour="monitoring-results-table"]',
            title: t.monitoringResultsTable.title,
            content: t.monitoringResultsTable.content,
        },
        {
            target: '[data-tour="monitoring-results-footer"]',
            title: t.monitoringResultsFooter.title,
            content: t.monitoringResultsFooter.content,
        },
    ]
}
